import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { resolvePublicAuthConfig } from '../config/public-env.js';

let browserClient: SupabaseClient | null = null;

export function getSupabaseBrowserClient(): SupabaseClient {
  if (browserClient) return browserClient;

  const config = resolvePublicAuthConfig();
  browserClient = createClient(config.supabaseUrl, config.supabasePublishableKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  });
  return browserClient;
}
